import { AnnotationPlugin } from '@st/document-viewer-kit'
import { FieldAnnotationElement } from './element'
import type {
  ViewerFieldAnnotation,
  ContractFieldAnnotation
} from '~/st-doc-viewer/viewer-annotations'
import type { FieldToolState } from '~/st-doc-viewer/annotations'
import { FieldToolOverlay } from './placement'

export function fieldPlugin(): AnnotationPlugin<ViewerFieldAnnotation, FieldToolState> {
  return {
    name: 'field',
    initialToolState: {
      name: 'field',
      settings: {}
    },
    ToolOverlay: FieldToolOverlay,
    Element: FieldAnnotationElement,
    handlesAnnotation: (annotation) => annotation.type == 'field',
    completeAnnotation: (annotation) => ({
      ...annotation,
      field: {
        ...(annotation as ContractFieldAnnotation).field,
        id: annotation.id,
        page: annotation.pageNumber,
        rect: annotation.bounds
      }
    })
  }
}
